import { render, staticRenderFns } from "./ConceptsList.vue?vue&type=template&id=0227da30&scoped=true&"
import script from "./ConceptsList.vue?vue&type=script&lang=ts&"
export * from "./ConceptsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0227da30",
  null
  
)

export default component.exports